import { secondaryAuth, auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { db } from "./firebase";
import { doc, setDoc } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import Swal from "sweetalert2";

export const doCreateUserWithEmailAndPassword = async (
  email,
  password,
  telefono,
  nombre
) => {
  try {
    const result = await createUserWithEmailAndPassword(
      secondaryAuth,
      email,
      password
    );

    if (result.user) {
      const userProfileDocumentReference = doc(db, "usuarios", result.user.uid);

      await setDoc(userProfileDocumentReference, {
        nombre: nombre,
        email: email,
        telefono: telefono,
        clase_grabada: false,
        clase_online: false,
        fecha_creacion: serverTimestamp(),
      });

      return true; // Indica que la operación fue exitosa
    } else {
      throw new Error("No se pudo crear el usuario");
    }
  } catch (error) {
    console.log(error);
    throw error; // Re-lanza el error
  }
};

export const doSignInWithEmailAndPassword = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password);
};

export const doSignInWithGoogle = async () => {
  try {
    const provider = new auth.GoogleAuthProvider();
    const result = await auth.signInWithPopup(provider);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const doSignOut = async () => {
  try {
    await auth.signOut();
    await secondaryAuth.signOut();
  } catch {
    console.log("Error al cerrar sesión");
  }
};

export const doPasswordReset = async (email) => {
  try {
    if (!email) {
      throw new Error("¡No ingresaste ningún email!");
    }
    await sendPasswordResetEmail(auth, email);
    Swal.fire({
      icon: "success",
      title: "¡Correo enviado!",
      text: "Revisa tu correo electrónico para restablecer tu contraseña.",
    });
  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error.message,
    });
  }
};
